import React, { useEffect, useState } from 'react';
import Avatar from '@material-ui/core/Avatar';
// import Button from '@material-ui/core/Button';
// import Input from '@material-ui/core/Input';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import {useDataProvider} from "react-admin";
// import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import AppBar from "../../Components/header/index"
// import SignInButton from "../../button/globleButtons";
import AppProvider from "../../Components/bootstrap/index"
// import Logo from "../../../images/Mainlogo.png"
// import LinkedinLogo from "../../../images/linkedin.png";
// import GoogleLogo from "../../../images/google.png"
const Profile = require('../../images/profile.png');
const useStyles = makeStyles(theme => ({
  '@global': {
    body: {
      backgroundColor: theme.palette.common.white,
    },
  },
  paper: {
    // marginTop: theme.spacing(1),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: 10,
    width: 300,
    height: 60,
    // margin: theme.spacing(1),
    backgroundColor: 'white',
  },
  large: {
    width: theme.spacing(15),
    height: theme.spacing(15),
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  TextField:{
    marginTop:"8%",
    backgroundColor:"#ffffff"
  },
  coverBackgroundContainer: {
    backgroundColor:"#F7F8F9",
    height: "100vh",
    backgroundSize: "cover",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    paddingLeft:"4%",
    paddingRight:"4%",
    paddingTop:"40px",
    // paddingBottom:"20px"
  },
}));
const MenteeProfile=(props)=> {
  const classes = useStyles();
  // const {
  //   handleSubmit,
  // } = props
  const dataProvider= useDataProvider();
  const [dataList,setDataList]=useState([]);
  useEffect(() => {
    const runEffect = async () => {
    const data = await dataProvider.getList("User", {
    filter: {},
    pagination: { page: 1, perPage: 10 },
    sort: { field: "id", order: "ASC" }
    });
    console.log("dat--->",data)
    setDataList(
    data.data.map(key => ({
    id: key.id,
    email: key.email,
    phn:key.mobileNo,
    certificaton:key.certificaton,
    description:key.description
    }))
    );
    };
    runEffect();
    }, [setDataList, dataProvider]);
    console.log("this is data from User=>",dataList)
  return (
    <div className={classes.coverBackgroundContainer}>
    <AppProvider >
      <AppBar />
      <Avatar src={Profile}  alt={"123Mentor"} className={classes.large}/>
      <Box mt={2}>
      </Box>
    <Container component="main" maxWidth="sm" style={{background:"#ffffff",}}>
      <div className={classes.paper} >
      <form
              // className={classes.form}
              // onSubmit={handleSubmit}
              // autoComplete="off"
            >
      <Grid container spacing={2} style={{margin: "5 %"}} >
        {/* <form className={classes.form}   > */}
          <Grid item xs={12} sm={6}>
           <TextField
           className={classes.TextField}
           autoFocus
             id="Email Address"
             name="email"
            //  required
            disabled
            //  placeholder="Email Address"
            // defaultValue="katorechanchal98@gmail.com"
             label="Email Address"
             type="Email Address"
             autoComplete="Email Address"
             variant="standard"
             fullWidth
             InputProps={{
              readOnly: true,}}
             />
             </Grid>
             <Grid item xs={12} sm={6}>
        <TextField
           className={classes.TextField}
           autoFocus
           id="standard-number"
          label="Number" 
          name="mobileNo"
          // defaultValue="9822827169"
            //  required
            disabled
             placeholder="Contact Number"
            //  label="Account Number"
             type="Contact Number"
             autoComplete="Contact Number"
             variant="standard"
             fullWidth
             InputProps={{
              readOnly: true,}}
             />
  </Grid>
  <Grid item xs={12} sm={6}>
        <TextField
            className={classes.TextField}
            autoFocus
             id="Location"
             defaultValue="pune"
             name="Location"
            //  required
             multiline
             disabled
             placeholder="Location"
             label="Location"
             type="Location"
             autoComplete="Location"
             variant="standard"
             fullWidth
             InputProps={{
              readOnly: true,}}
        />
        </Grid>
        <Grid item xs={12} sm={6} >
        <TextField
            className={classes.TextField}
            autoFocus
             id="Certificaton"
            //  defaultValue="java"
             name="certificaton"
            //  required
             multiline
             disabled
            //  placeholder="Certification"
            label="Certification"
             type="Certificaton"
             autoComplete="Certificaton"
             variant="standard"
             fullWidth
             InputProps={{
              readOnly: true,}}
        />
        </Grid>
        <Grid item xs={12} sm={12}>
         <TextField
            className={classes.TextField}
            autoFocus
            //  required
             multiline
             disabled
             name="description"
            //  placeholder="Description"
             label="Description"
             defaultValue="i am chanchal"
             type="Description"
             autoComplete="Description"
             variant="standard"
             fullWidth
             InputProps={{
              readOnly: true,}}
        />
        </Grid>
        <div style={{marginTop:"10%"}}>
          {/* <SignInButton buttonname="Submit Details" /> */}
          </div>
        {/* </form> */}
        </Grid>
        </form>
      </div>
      <Box mt={8}>
      </Box>
    </Container>
    </AppProvider>
    </div>
  );

}
// const MenteeProfile = compose(
//   withFormik({
//     // mapPropsToStatus: props => ({
//     //   isDisabled: {}
//     // }),
//     mapPropsToValues: (props) => ({
//       firstname:props.CollectedLeadData.firstname,
//       lastname:props.CollectedLeadData.lastname,
//       email:props.CollectedLeadData.email,
//       mobile_no:props.CollectedLeadData.mobile_no,
//     }),
    // validationSchema: Yup.object().shape({
    //   firstname: Yup.string("firstname is required and should be a String")
    //     .min(3, "firstname must be length of 3 to 12!")
    //     .max(12, "Too Long!")
    //     .required("First Name is required"),
    //   lastname: Yup.string("lastname is required and should be a String")
    //     .min(3, "lastname must be length of 3 to 12!")
    //     .max(12, "Too Long!")
    //     .required("Last Name is required"),
    //   email: Yup.string("Username is required and should be a String")
    //     .required(" Email Address is required")
    //     .matches(EmailRegex,"Email Address is invalid"),
    //   mobile_no: Yup
    //     .string()
    //     .required('Please Enter your mobile number')
    //     .matches(
    //       /^\([0-9]{3}\)[0-9]{3}-[0-9]{4}$/,
    //       "Enter 10 digit number"
    //     ),
    //     }),
    // handleSubmit: (values, formikBag) => {
    //   console.log("formikBag", formikBag);
    //   console.log("values", values);
    //   actions.SetPersonalInfo({ values, formikBag });
    //   actions.PushStageAndPayload({ stagename:"personalinfo",values, formikBag });
    //   // actions.SetDollarValue();
    // }
  // })
// )(PersonalInfo);
export default MenteeProfile;

